<template>
    <div class="container admin-table-page">
        <!-- Fila del título y flecha hacia atrás -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>
        <!-- Fila de filtros debajo del título a la izquierda -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="filters-container d-flex align-items-center">
                    <input type="month" v-model="validity">                  
                    <b-button
                        class="consult-btn ml-2"
                        @click="consultaCalificacion()"
                        :disabled="!validity"
                    >
                        <font-awesome-icon :icon="['fas', 'search']" class="mr-1" />
                        {{ labels.consultar }}
                    </b-button>
                </div>
            </div>
        </div>
        <div class="admin-table-block mt-4">
            <div v-if="!isLoading">
                <CorporateDataTable
                    :items="listVigencias"
                    :fields="allFields"
                    :labels="tableLabels"
                    :default-per-page="10"
                    :page-options="[10, 20, 50, 100]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="showSearchTable"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="tableFilterDefs"
                    :toolbar-disabled="!showToolbarExtras"
                    @row-clicked="(item) => editCalificacion(item.id)"
                >
                    <template #toolbar-actions>
                        <b-button 
                            size="sm" 
                            class="table-toolbar-add-btn" 
                            @click="createCalificacion()"
                            :disabled="validity"
                        >
                            {{ labels.addCalificacion }}
                        </b-button>
                        <div class="niif-toolbar-right">
                            <b-button
                                size="sm"
                                class="table-toolbar-excel-btn"
                                @click="genExcelCalificacion()"
                                :disabled="!showToolbarExtras || listVigencias.length === 0"
                            >
                                <font-awesome-icon :icon="['fas', 'file-excel']" class="mr-1" />
                            </b-button>
                        </div>
                    </template>
                    <template #cell(score)="{ item }">
                        <span class="badge-score">{{ formatNumber(item.score) }}</span>
                    </template>
                </CorporateDataTable>
            </div>
            <!-- Spinner de carga -->
            <div v-if="isLoading" class="text-center py-5">
                <b-spinner></b-spinner>
                <p class="mt-2">{{ labels.loading }}</p>
            </div>
        </div>
        <Crear :modalCrear="showModCrear" :infoVigencia="validity" @creado="consultaCalificacion()" @cierraModal="closeModal"></Crear>
        <Editar :modalEditar="showModEditar" :infoCalificacion="listCalificacion" @actualizado="consultaCalificacion()" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import Calificacion from '../../../services/Calificacion'; 
import Crear from './Crear.vue'; 
import Editar from './Editar.vue'; 
import CorporateDataTable from '../../utils/CorporateDataTable.vue';
export default {
    name : 'Calificacion',
    components : {Crear,Editar,CorporateDataTable},
    data : () => ({
        listVigencias : [],
        showModCrear : false,
        showModEditar : false,
        listCalificacion : [],
        validity : '',
        isLoading: false,
        showToolbarExtras: false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Calificación',
                    validity : 'Vigencia',
                    consultar : 'Consultar',
                    calificacion : 'Calificación',
                    descripcion : 'Descripción',
                    score : 'Score',
                    filterCalificacion : 'Filtrar calificación...',
                    filterDescripcion : 'Filtrar descripción...',
                    filterScore: 'Filtrar score...',
                    noRow : "No hay registros",
                    noData: 'No hay datos disponibles',
                    noMatches: 'No se encontraron resultados',
                    searchPlaceholder: 'Buscar en la tabla...',
                    rowsPerPage: 'Filas por página:',
                    noSort: 'Sin orden',
                    sortAsc: 'A-Z / Menor a mayor',
                    sortDesc: 'Z-A / Mayor a menor',
                    columns: 'Columnas',
                    showAllColumns: 'Mostrar todas',
                    filters: 'Filtros',
                    clearFilters: 'Limpiar filtros',
                    addCalificacion: 'Añadir calificación',
                }
            }else{
                return {
                    title : 'Rating',
                    validity : 'Validity',
                    consultar : 'Consultar',
                    calificacion : 'Calification',
                    descripcion : 'Description',
                    score : 'Score',
                    filterCalificacion : 'Filter by rating...',
                    filterDescripcion : 'Filter description...',
                    filterScore: 'Filter score...',
                    noRow : "There are not records",
                    selectReport : 'Select Date',
                    loading: 'Loading...', 
                    noData: 'No data available',
                    noMatches: 'No results found',
                    searchPlaceholder: 'Search in table...',
                    rowsPerPage: 'Rows per page:',
                    noSort: 'No sorting',
                    sortAsc: 'A-Z / Low to high',
                    sortDesc: 'Z-A / High to low',
                    columns: 'Columns',
                    showAllColumns: 'Show all',
                    filters: 'Filters',
                    clearFilters: 'Clear filters',
                    addCalificacion: 'Add rating',
                }
            }
        },
        allFields() {
            return [
                { key: 'calificacion', label: this.labels.calificacion, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '200px' } },
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left', tdClass: 'text-center align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '200px' } },
                { key: 'score', label: this.labels.score, sortable: true, thClass: 'text-left', tdClass: 'text-start align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '200px' } },
            ]
        },
        tableFilterDefs() {
            return [
                { key: 'calificacion', type: 'text', placeholder: this.labels.filterCalificacion },
                { key: 'descripcion', type: 'text', placeholder: this.labels.filterDescripcion },
                { key: 'score', type: 'text', placeholder: this.labels.filterScore },
            ]
        },
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        },
        showSearchTable() {
            return true
        }
    },
    methods : {
        goBack() {
            this.$router.back()
        },
        closeModal(val){
            this.showModCrear = val 
            this.showModEditar = val 
        },
        consultaCalificacion(){
            // let fecha = valNew+'-31'
            const fecha = this.validity+'-31'
            Calificacion.calificacionByVigencia(fecha) 
            .then((res) => { 
                // console.log(res.data); 
                this.listVigencias = res.data.calificaByVigencia
                
                if(this.listVigencias.length > 0){
                    this.showToolbarExtras = true
                }else{
                    this.$toast.error('No hay datos para la fecha consultada.')
                    this.showToolbarExtras = false
                }
            })
            .catch((err) => console.log(err)) 
        },
        createCalificacion(){
            this.showModCrear = true 
        },
        editCalificacion(id){
            // console.log(id); 
            Calificacion.calificacionById(id) 
            .then((res) => { 
                // console.log(res.data.calificacionById); 
                this.listCalificacion = res.data.calificacionById 
                // this.listCalificacion = res.data.calificaByVigencia 
                this.showModEditar = true 
            })
            .catch((err) => console.log(err)) 
            /*Calificacion.calificacionByVigencia(vigencia) 
            .then((res) => { 
                // console.log(res.data); 
                this.listCalificacion = res.data.calificaByVigencia 
                this.showModEditar = true 
            })
            .catch((err) => console.log(err))*/ 
        },
        formatNumber(value) {
            if (value === null || value === undefined) return ''
            return new Intl.NumberFormat('es-CO', { 
                minimumFractionDigits: 0, 
                maximumFractionDigits: 3 
            }).format(value)
        },
        genExcelCalificacion(){

        }
    },
    mounted(){
    },
    /*watch:{
        validity(valNew){
            // console.log(valNew); 
            let fecha = valNew+'-31'
            Calificacion.calificacionByVigencia(fecha) 
            .then((res) => { 
                // console.log(res.data); 
                this.listVigencias = res.data.calificaByVigencia 
            })
            .catch((err) => console.log(err)) 
        }
    }*/
}
</script>

<style scoped>
/* Estilos para el contenedor de filtros - ahora a la izquierda */
.niif-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.niif-header .filter-select {
    min-width: 200px;
    max-width: 280px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

/* Para que el texto de las opciones se vea completo */
.niif-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

.niif-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.niif-header .consult-btn:hover,
.niif-header .consult-btn:focus,
.niif-header .consult-btn:active,
.niif-header .consult-btn:not(:disabled):hover,
.niif-header .consult-btn:not(:disabled):focus,
.niif-header .consult-btn:not(:disabled):active {
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
    box-shadow: none !important;
}

.niif-header .consult-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
}

/* Estilos para la flecha y título */
.page-back-btn {
    padding: 0;
    font-size: 1.5rem;
    line-height: 1;
}

.back-icon {
    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;
}

.param-title {
    font-size: 2rem !important;
    font-weight: 500;
}

.niif-toolbar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto;
}

.table-toolbar-excel-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    background-color: #016690;
    color: white;
    border: 1px solid #085170;
}

.table-toolbar-excel-btn:hover:not(:disabled) {
    background-color: #085170;
    border-color: #0e3a4d;
}

.table-toolbar-excel-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* Ajustes responsivos */
@media (max-width: 1200px) {
    .niif-header .filter-select {
        min-width: 160px;
        max-width: 220px;
        height: 36px;
        font-size: 13px;
    }

    .niif-header .consult-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 992px) {
    .niif-header .filters-container {
        flex-wrap: wrap;
        width: 100%;
        margin-top: 8px;
        margin-left: 0 !important;
        justify-content: flex-start;
        gap: 6px;
    }

    .niif-header .filter-select {
        min-width: 150px;
        max-width: 200px;
        height: 36px;
        font-size: 13px;
        flex: 1 1 auto;
    }

    .niif-header .consult-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 576px) {
    .param-title {
        font-size: 1.5rem !important;
    }

    .niif-header .filter-select {
        min-width: 100%;
        max-width: 100%;
        height: 36px;
        font-size: 13px;
        flex: 0 0 100%;
    }

    .niif-header .filters-container {
        gap: 4px;
    }

    .niif-header .consult-btn {
        width: 100%;
        flex: 0 0 100%;
        height: 36px;
        margin-left: 0 !important;
        margin-top: 4px;
    }
}
</style>
